import * as CommentsActionTypes from './action-types.constants';
import * as RouterActionTypes from '../../main-router/action-types.constants';
function getDefaultState() {
    const DEFAULT_STATE = {
        "open": false,
        "content": ""
    }
    return DEFAULT_STATE;
}

const Comments = (state = getDefaultState(), action) => {
    let newState = {}

    const { type } = action;
    switch (type) {
        case CommentsActionTypes.OPEN:
            newState = {
                "open": true
            }
            break;
        case CommentsActionTypes.CLOSE:
            newState = {
                "open": false
            }
            break;

        case CommentsActionTypes.SET_CONTENT:
            newState = {
                "content": action.content
            }
            break;
        case RouterActionTypes.READY:
        case RouterActionTypes.HISTORY_LOCATION_CHANGE:
            newState = {
                "content": "",

            }
            break;

        default:
            newState = state
    }

    if (newState !== state) {
        newState = Object.assign({}, state, newState);
        //console.log("[Comments Reducers] Action Type: ", type)
        //console.log("[Comments Reducers] New State: ", newState)
    }
    return newState;
}

export default Comments;